export default __webpack_public_path__ + "static/media/undo.1f03f179.svg";